import { createSlice } from "@reduxjs/toolkit";

const cidSlice = createSlice({
  name: "cid",
  initialState: {
    value: {
      name: "",
      notes: "",
      legend: [],
      touched: false,
    },
  },
  reducers: {
    changeName: (state, action) => {
      state.value.name = action.payload;
    },
    changeNotes: (state, action) => {
      state.value.notes = action.payload;
    },
    changeLegend: (state, action) => {
      state.value.touched = true;
      if (action.payload.data !== undefined) {
        // Pad up to the edited index — writing past the end would create a
        // sparse array whose holes serialize to null, which the legend
        // String[] column rejects. (Legends saved before more marker colors
        // existed are shorter than MARKER_OPTIONS.)
        while (state.value.legend.length < action.payload.index) {
          state.value.legend.push("");
        }
        state.value.legend[action.payload.index] = action.payload.data;
      }
    },
    loadLegend: (state, action) => {
      state.value.legend = action.payload || [];
      state.value.touched = false;
    },
    markLegendSaved: (state) => {
      state.value.touched = false;
    },
  },
});

export const { changeName, changeLegend, changeNotes, loadLegend, markLegendSaved } =
  cidSlice.actions;

export default cidSlice.reducer;
